import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './SummaryStepForm.jsx'

export default createSubmit(name)